import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { User, ApiResponse } from '@app/_models';
import { SharedService } from './../_components/_shared/shared.service';


@Injectable({ providedIn: 'root' })
export class UserService
{
	constructor(
		private http: HttpClient,
		private sharedService: SharedService
	) { }

	urlEndpoint = 'users';

	add(user: User): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(user));
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }`, user);
	}

	getSalesmen(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${ this.urlEndpoint }/find-all/salesmen`).pipe(retry({ count: 2, delay: 1500 }));
	}

	addUserContact(user: User): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(user));
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/add-user-contact`, user);
	}

	update(user: User): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(user));
		return this.http.patch<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }`, user);
	}

	updateUserContact(user: User): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(user));
		return this.http.patch<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/update-user-contact`, user);
	}

	delete(id: number): Observable<ApiResponse>
	{
		return this.http.delete<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/${ id }`);
	}

	findAll(): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse>
	{

		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log(JSON.stringify(params));
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));
	}

	findTeamUsers(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse>
	{

		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByTask(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any, taskId: any): Observable<ApiResponse>
	{
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		// add the taskId
		if (taskId) { params = params.append('taskId', taskId); }

		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/find-by-task`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));
	}

	findById(id: number): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/${ id }`).pipe(retry({ count: 2, delay: 1500 }));
	}
	
	findUsersWith(queryString: string): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/users/find-with?query=${ queryString }`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findUsersWithEmployeeRelationship(queryString: string): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/users/find-user-with-employee?query=${ queryString }`).pipe(retry({ count: 2, delay: 1500 }));
	}

	register(user: User): Observable<ApiResponse>
	{
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/register`, user);
	}

	resetPasswordRequest(user: User): Observable<ApiResponse>
	{
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/reset-password-request?referringUrl=${ environment.referringUrl }`, user);
	}

	resetPassword(user: User): Observable<ApiResponse>
	{
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/reset-password`, user);
	}

	getEmailReportOfHomeOwnerArrival(): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/reservations/home-owner-arrival`).pipe(retry({ count: 2, delay: 1500 }));
	}

	getEndPointResponse(endPoint: any): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${endPoint}`);
	}

	postEndPointResponse(endPoint: any, payload: any = {}): Observable<ApiResponse>
	{
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/${endPoint}`, payload);
	}

	getQRCode(qrCodeInfo: any): Observable<ApiResponse>
	{
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/guest-portal/wifi-info`, qrCodeInfo);
	}
	// https://gt-tech.bitbucket.io/spring-data-querydsl-value-operators/README.html

	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any)
	{
		try
		{
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta)
			{
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++)
				{
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters)
			{
				// https://bitbucket.org/gt_tech/spring-data-querydsl-value-operators/src/master/
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++)
				{
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);

					// if using lt, gt, etc
					// params = params.append(keys[i], filters[keys[i]].matchMode + '(' + filters[keys[i]].value + ')');
				}
			}
			return params;
		} catch (error)
		{
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
	
	
}
